module.exports = __webpack_public_path__ + "81c632195c41f49078616ac825c3e804.svg";